import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Radio, Zap } from "lucide-react";

export default function AdminLogs() {
  const [tab, setTab] = useState("whatsapp");
  const [wa, setWa] = useState([]);
  const [ss, setSs] = useState([]);

  useEffect(() => {
    api.get("/admin/whatsapp-logs").then((r) => setWa(r.data));
    api.get("/admin/sports-sync-logs").then((r) => setSs(r.data));
  }, []);

  const simulateSync = async () => {
    await api.post("/admin/sports-sync/simulate", {
      provider: "cricheroes",
      event: "match_ingest",
      match: { teams: ["Star XI", "Falcons"], winner: "Star XI", score: "192/6" },
    });
    api.get("/admin/sports-sync-logs").then((r) => setSs(r.data));
  };

  return (
    <div data-testid="admin-logs">
      <div className="font-mono text-xs uppercase tracking-[0.3em] brand-orange mb-3">// Integrations · Mock Logs</div>
      <h1 className="font-display text-4xl font-black uppercase tracking-tighter leading-none mb-8">Webhook Logs.</h1>

      <div className="flex gap-2 mb-6">
        <button onClick={() => setTab("whatsapp")} data-testid="tab-whatsapp" className={`px-5 py-2 border font-mono text-xs uppercase tracking-widest ${tab === "whatsapp" ? "bg-brand-blue text-white border-brand-blue" : "border-white/20 text-white/60"}`}>
          <Zap size={12} className="inline mr-2" />WhatsApp ({wa.length})
        </button>
        <button onClick={() => setTab("sync")} data-testid="tab-sync" className={`px-5 py-2 border font-mono text-xs uppercase tracking-widest ${tab === "sync" ? "bg-brand-orange text-black border-brand-orange" : "border-white/20 text-white/60"}`}>
          <Radio size={12} className="inline mr-2" />Sports Sync ({ss.length})
        </button>
        <button onClick={simulateSync} data-testid="simulate-sync" className="ml-auto px-5 py-2 border border-brand-orange text-brand-orange font-mono text-xs uppercase tracking-widest hover:bg-brand-orange hover:text-black">
          Simulate CricHeroes ingest
        </button>
      </div>

      {tab === "whatsapp" && (
        <div className="border border-white/12 bg-[#131A2B]">
          {wa.map((l) => (
            <div key={l.id} className="p-4 border-b border-white/5 flex items-start gap-4">
              <div className="w-2 h-2 bg-brand-blue rounded-full mt-2"></div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-3 text-xs font-mono text-white/40 mb-1">
                  <span className="brand-blue uppercase tracking-widest">{l.event}</span>
                  <span>{l.phone}</span>
                  <span>{l.triggered_at?.slice(0, 19).replace("T", " ")}</span>
                </div>
                <div className="text-sm text-white/80">{l.message}</div>
              </div>
            </div>
          ))}
          {wa.length === 0 && <div className="p-8 text-center text-white/40">No WhatsApp events yet.</div>}
        </div>
      )}

      {tab === "sync" && (
        <div className="border border-white/12 bg-[#131A2B]">
          {ss.map((l) => (
            <div key={l.id} className="p-4 border-b border-white/5">
              <div className="flex items-center gap-3 text-xs font-mono text-white/40 mb-1">
                <span className="brand-orange uppercase tracking-widest">{l.provider}</span>
                <span>{l.event}</span>
                <span>{l.received_at?.slice(0, 19).replace("T", " ")}</span>
              </div>
              <pre className="text-xs text-white/70 whitespace-pre-wrap font-mono">{JSON.stringify(l.payload, null, 2)}</pre>
            </div>
          ))}
          {ss.length === 0 && <div className="p-8 text-center text-white/40">No sync events yet. Click "Simulate" above.</div>}
        </div>
      )}
    </div>
  );
}
